import type { IInspectionDetails } from "@/types/types";
import { create } from "zustand";

interface InspectionIdState {
  inspectionId: string;
  isNewInspectionId: boolean;
  inspectionData: null | IInspectionDetails;
  snStand: string;
  updateInspectionId: (inpsection: string) => void;
  updateIsNewInspectionId: (isNew: boolean) => void;
  updateInspectionData: (newInspectionData: null | IInspectionDetails) => void;
  updateSnStand: (snStand: string) => void;
  updateAll: (params: {
    inspectionId?: string;
    isNewInspectionId?: boolean;
    endedInspection?: boolean;
    snStand: string;
  }) => void;
  clearInpectionStatus: () => void;
}

const useInspectionId = create<InspectionIdState>((set) => ({
  inspectionId: "",
  isNewInspectionId: false,
  inspectionData: null,
  snStand: "",
  updateInspectionId: (inspection: string) => set({ inspectionId: inspection }),
  updateIsNewInspectionId: (isNew: boolean) =>
    set({ isNewInspectionId: isNew }),
  updateSnStand: (snStand: string) => set({ snStand }),
  updateAll: (params) => set({ ...params }),
  updateInspectionData: (data: null | IInspectionDetails) =>
    set({ inspectionData: data }),
  clearInpectionStatus: () =>
    set({
      inspectionId: "",
      isNewInspectionId: false,
      inspectionData: null,
      snStand: "",
    }),
}));

export default useInspectionId;
